import React, { ReactElement } from 'react';
import useStyles from '../../styles';
import { Control, DeepMap, FieldError, useForm } from 'react-hook-form';
import {
  AppSelect,
  AppTextField,
} from '../../../../../../components/molecules/form_controls';
import GridLayout from '../../../../../../components/molecules/grid_layout';
import { getState } from '../../../../../../redux/store';
import { ReducerKeys } from '../../../../../../redux/reducers';
import RegistrationDetailActions from '../../../../../../redux/reducers/registration_detail_reducer/actions';
import * as RegistrationDetailSelectors from 'redux/reducers/registration_detail_reducer/selectors';
import { useDispatch } from 'react-redux';
import ModalActions from '../../../../../../redux/reducers/gl_modal_reducer/actions';
import { ModalIDs } from '../../../../../../redux/reducers/gl_modal_reducer/types';
import { Button } from '@material-ui/core';
import TranslatedText from '../../../../../../components/atoms/translated_text';
import { Translations } from '../../configuration';
import { IdentificationInOtherEuCountriesInput } from '../../model';
import { isVatNumberValid } from 'utils/general';

interface FormFields {
  vatNumOtherEu: string | null;
  issuingCountryOtherEu: string | null;
}

export default function IdentificationOfOtherEuCountriesForm(): ReactElement {
  const dispatch = useDispatch();
  const defaultValues = {
    vatNumOtherEu: null,
    issuingCountryOtherEu: null,
  };
  // console.log('Render IdentificationOfOtherEuCountriesForm');

  const { errors, control, handleSubmit, setError } = useForm({
    defaultValues,
  });
  const classes = useStyles();

  const onSubmit = (data: any) => {
    if (!isVatNumberValid(data.vatNumOtherEu)) {
      setError('vatNumOtherEu', {
        type: 'manual',
        message: `Invalid VAT Number format`,
      });
      return;
    }

    let reduxData = getState(
      ReducerKeys.REGISTRATION_DETAIL_REDUCER
    ).identificationInOtherEuCountries;
    let newData: Array<IdentificationInOtherEuCountriesInput> =
      new Array<IdentificationInOtherEuCountriesInput>();
    for (let item of reduxData) newData.push(item);
    let countries = getState(ReducerKeys.REGISTRATION_DETAIL_REDUCER)
      .memberStateCountries.data;

    let newIdentification: IdentificationInOtherEuCountriesInput = {
      vat_id_num: data.vatNumOtherEu,
      country_id:
        countries[Number.parseInt(data.issuingCountryOtherEu) - 1].country_id,
      id: 0,
      country:
        countries[Number.parseInt(data.issuingCountryOtherEu) - 1].description,
    };
    newData.push(newIdentification);
    dispatch(
      RegistrationDetailActions.setIdentificationInOtherEuCountriesAction(
        newData
      )
    );
    dispatch(
      ModalActions.closeModalAction({
        modalID: ModalIDs.MODAL_IDENTIFICATION_IN_OTHER_EU_COUNTRIES,
      })
    );
  };

  return (
    <form
      className={classes.form}
      noValidate
      onSubmit={handleSubmit(onSubmit)}
      id={'identificationInOtherEuCountriesForm'}
    >
      <GridLayout
        elements={[
          {
            element: renderVatNumberField(errors, control),
            size: 12,
            id: 'vatNumOtherEu',
          },
          {
            element: renderIssuingCountryField(errors, control),
            size: 12,
            id: 'issuingCountryOtherEu',
          },
          {
            element: (
              <Button
                variant="contained"
                color="primary"
                type="submit"
                style={{ width: '100%' }}
                form={'identificationInOtherEuCountriesForm'}
              >
                <TranslatedText textMap={Translations.add} />
              </Button>
            ),
            size: 12,
            id: 'action',
          },
        ]}
      />
    </form>
  );
}

const renderVatNumberField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  return (
    <AppTextField
      variant="outlined"
      margin="normal"
      required
      fullWidth
      id="vatNumOtherEu"
      label={<TranslatedText textMap={Translations.vat_number_label} />}
      error={'vatNumOtherEu' in errors}
      name="vatNumOtherEu"
      control={control}
      rules={{
        required: 'Required Field',
        maxLength: { value: 12, message: 'Maximum length 12' },
      }}
      helperText={errors.vatNumOtherEu && errors.vatNumOtherEu.message}
    />
  );
};

const renderIssuingCountryField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  // let countries = getState(ReducerKeys.REGISTRATION_DETAIL_REDUCER)
  //   .nonMemberStateCountries.data;
  let countries = RegistrationDetailSelectors.useGetCountriesMemberState();
  let select_countries = [];
  select_countries.push({
    id: null,
    label: Translations.issuing_country_label.English,
  });
  if (countries && countries.length > 0)
    countries.map((country: any, index: number) => {
      select_countries.push({
        id: index + 1,
        label: country.description,
      });
    });

  return (
    <AppSelect
      variant="outlined"
      margin="normal"
      required
      fullWidth
      id="issuingCountryOtherEu"
      label={<TranslatedText textMap={Translations.issuing_country_label} />}
      error={'issuingCountryOtherEu' in errors}
      name="issuingCountryOtherEu"
      control={control}
      rules={{ required: 'Required Field' }}
      options={select_countries as any}
      helperText={
        errors.issuingCountryOtherEu && errors.issuingCountryOtherEu.message
      }
    />
  );
};
